import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TranslationProvider } from '@/hooks/useTranslation';
import { I18nProvider } from '@/common/I18nProvider';
import ThemeProvider from '@/common/ThemeProvider';
import StructuredData from '@/components/SEO/StructuredData';

// Home Pages
import HomeOne from '@/components/homes/home-1';

// Other Pages
import Aboutus from '@/components/Aboutus';
import Services from '@/components/Services';
import Projects from '@/components/Projects';
import Contact from '@/components/Contact';
import Faq from '@/components/Faq';
import NotFound from '@/components/error';

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <TranslationProvider>
        <I18nProvider>
          <ThemeProvider />
          <StructuredData />
          <Routes>
            {/* Home Routes */}
            <Route path="/" element={<HomeOne />} />
            <Route path="/home-1" element={<HomeOne />} />

            {/* Other Pages */}
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </I18nProvider>
      </TranslationProvider>
    </BrowserRouter>
  );
}

export default App;

